import { render, staticRenderFns } from "./RMultiselect.vue?vue&type=template&id=0843af41"
import script from "./RMultiselect.vue?vue&type=script&lang=js"
export * from "./RMultiselect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports